// Excel 자동 시트 선택 기능을 위한 서비스 및 시트 매핑 상수

export enum ServiceType {
  CONTRACT_DETAILS = 'start-1',           // 계약내역서
  INCREASE_ACTUAL_REPORT = 'change-7',    // 증감 실정보고
  INCREASE_DETAILS = 'change-2',          // 증감
  ACTUAL_REPORT = 'change-1',             // 실정보고
  PROGRESS_DETAILS = 'progress-1',        // 기성내역서
  COMPLETION_DETAILS = 'completion-1',    // 준공내역서
  PHASED_STATEMENT = 'change-8'           // 차수분내역서
}

// 서비스별 필요한 시트 매핑
export const SERVICE_REQUIRED_SHEETS = {
  [ServiceType.CONTRACT_DETAILS]: ['원가', '내역'],
  [ServiceType.INCREASE_ACTUAL_REPORT]: ['원가', '집계', '내역'],
  [ServiceType.INCREASE_DETAILS]: ['원가', '집계', '내역'],
  [ServiceType.ACTUAL_REPORT]: ['원가', '집계', '내역'],
  [ServiceType.PROGRESS_DETAILS]: ['원가', '집계', '내역'],
  [ServiceType.COMPLETION_DETAILS]: ['원가', '집계', '내역'],
  [ServiceType.PHASED_STATEMENT]: ['원가', '집계', '내역']
} as const;

// 시트명 매칭을 위한 키워드 매핑
export const SHEET_KEYWORDS = {
  원가: ['원가', '직접비', '공사원가', '원가계산'],
  집계: ['집계', '총괄', '종합', '합계', '총괄집계표', '집계표'],
  내역: ['내역', '세부내역', '공사내역', '상세내역']
};

// 시트명 매칭 시 제외할 키워드 매핑
// 예: '내역' 키워드로 검색 시 '총괄', '집계'가 포함된 시트는 낮은 우선순위로 처리
export const EXCLUSION_KEYWORDS = {
  내역: ['총괄', '집계', '증감'],
  원가: ['총괄', '집계'],
  집계: ['증감']
} as const;

// 서비스명 매핑 (사용자 알림용)
export const SERVICE_NAMES = {
  [ServiceType.CONTRACT_DETAILS]: '계약내역서',
  [ServiceType.INCREASE_ACTUAL_REPORT]: '증감 실정보고',
  [ServiceType.INCREASE_DETAILS]: '증감',
  [ServiceType.ACTUAL_REPORT]: '실정보고',
  [ServiceType.PROGRESS_DETAILS]: '기성내역서',
  [ServiceType.COMPLETION_DETAILS]: '준공내역서',
  [ServiceType.PHASED_STATEMENT]: '차수분내역서'
} as const;

// 알림 타입 정의
export enum NotificationType {
  COMPLETE_SUCCESS = 'complete_success',
  PARTIAL_SUCCESS = 'partial_success',
  NO_SELECTION = 'no_selection'
}

// 시트 선택 결과 인터페이스
export interface SheetSelectionResult {
  selectedSheets: string[];
  missingSheets: string[];
  requiredSheets: string[];
}

// 알림 결과 인터페이스
export interface NotificationResult {
  type: NotificationType;
  message: string;
}

// 파일이 필요한 서비스 타입 체크를 위한 배열
export const FILE_REQUIRED_SERVICES = [
  ServiceType.CONTRACT_DETAILS,
  ServiceType.INCREASE_ACTUAL_REPORT,
  ServiceType.INCREASE_DETAILS,
  ServiceType.ACTUAL_REPORT,
  ServiceType.PROGRESS_DETAILS,
  ServiceType.COMPLETION_DETAILS,
  ServiceType.PHASED_STATEMENT
] as const;

/**
 * 서비스 타입이 파일을 필요로 하는지 확인하는 함수
 * @param serviceType 서비스 타입 (string)
 * @returns 파일 필요 여부
 */
export const isFileRequiredService = (serviceType: string): serviceType is ServiceType => {
  return Object.values(ServiceType).includes(serviceType as ServiceType);
};

// 서비스 타입 체크 헬퍼 타입
export type RequiredSheetType = keyof typeof SHEET_KEYWORDS;
export type ServiceTypeKey = keyof typeof SERVICE_REQUIRED_SHEETS;